export class PricePremiumUfModel {
    uf: string;
    serviceContract: string;
    premiumPercent: string;
    isEnabled: boolean;
}
